import { Component, EventEmitter, OnInit, Output,Input} from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  @Input() filterText:any;
  @Output() filterValue = new EventEmitter<any>();

  constructor() { /* TODO document why this constructor is empty */ }

  ngOnInit(): void {  
    // TODO document why this method 'ngOnInit' is empty
    this.filterText = this.filterText?this.filterText:'All';
  }

  applyFilter(event: Event) {
    this.filterValue.emit(event);
  }

}
